export var YM_ID = 26001372;
export var ymGoal = {
  WebChatStart: 'WebChatStart'
};
export var chatAnalyticsAction = {
  chatIconAction: 'chat_icon_action',
  chatAction: 'chat_action',
  viewItem: 'view_item',
  chatError: 'chat_error',
  click: 'click',
  close: 'close',
  view: 'view',
  error: 'error',
  fill_in: 'fill_in'
};
export var AuthTypeAnalytics = /*#__PURE__*/function (AuthTypeAnalytics) {
  AuthTypeAnalytics["az"] = "az";
  AuthTypeAnalytics["nz"] = "nz";
  return AuthTypeAnalytics;
}({});
export var chatIconAction = {
  open: 'open',
  start: 'start',
  hide: 'hide'
};
export var chatAction = {
  startTyping: 'start_typing',
  sendMessage: 'send_message',
  tapFaq: 'tap_faq',
  tapMenu: 'tap_menu',
  viewMenu: 'view_menu',
  closeChat: 'close_chat'
};
export var viewChatItemAction = {
  troubleNotificationViewed: 'view_trouble_notif',
  faqViewed: 'view_faq'
};
export var chatErrorAction = {
  socketConnectionFailed: 'socket_connection_failed',
  messageNotSent: 'message_not_sent'
};
export var IS_START_ANSWER_MES = '__is_start_answer_mes';